import { Dayjs } from 'dayjs';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import DistributionType from '../../enums/@shared/DistributionType';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface ContactActionPayload {
  apiKey: string;
  contactIds: string[];
  scenarioId: string | null;
  owner: string | null;
  actionCanceled: boolean;
  actionProgrammed: boolean;
  distribution: DistributionType | null;
  startDistributionDate: Dayjs | null;
}

async function launchContactsActionsGroup(
  auth: Authentication,
  payload: ContactActionPayload
): Promise<void> {
  try {
    await HttpClient.post(
      '/contact/launch/action',
      payload,
      auth.token,
      false,
      {
        'x-api-key': payload.apiKey,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new LaunchContactsActionsGroupFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new LaunchContactsActionsGroupFailure(e.message);
    }
  }
}

export class LaunchContactsActionsGroupFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default launchContactsActionsGroup;
